$(document).ready(function () {
    setupSubmitEvents();

    function setupSubmitEvents() {
        let updatePassword = $('form.mylla-update-details-form--password');
        $(updatePassword).submit(function (event) {
            event.preventDefault();
            let form = $(this);
            if (form.valid()) {
                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form.serialize(),
                    success: function (result) {
                        $('#updatePasswordFormContainer').html(result);
                        setupSubmitEvents();

                        let updateDetailsEvent = new CustomEvent("myLLAUpdateDetailsSubmitted");
                        document.dispatchEvent(updateDetailsEvent);
                    }
                });
            }
        });
    }
});